import type { Document, PermissionResponse } from "~~/api/models";
import type {Form} from 'vee-validate';

export type FilterPill = { type: string, value: string, label: string };
export type CachedDocuments = { [key: string]: Document[] }
export type CachedUserPermissions = { [key: string]: PermissionResponse[] }
export type CachedFilters = { [key: string]: FilterPill[] }
export type ActiveItem = {
    itemId: string,
    tenantId: string
}
export enum ItemSelection {
  NONE = 'none',
  ALL = 'all',
  SELECTION = 'selection'
}
export type SortDir = 'asc' | 'desc' | 'none';
export interface SortItem { column: string; direction: SortDir; }
export type VeeFormInstance = InstanceType<typeof Form>